import { render, staticRenderFns } from "./drop-zone-single.vue?vue&type=template&id=4e5bba44&"
import script from "./drop-zone-single.vue?vue&type=script&lang=js&"
export * from "./drop-zone-single.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports